/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForOpenStack extends models.ServiceAccountCredentialsBaseForOpenStack {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForOpenStack");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForOpenStack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForOpenStack>): ServiceAccountCredentialsForOpenStack {
        let obj = Object.assign(new ServiceAccountCredentialsForOpenStack(), model);
        ServiceAccountCredentialsForOpenStack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForOpenStack>): ServiceAccountCredentialsForOpenStack {
        if (!model) return null;
        return ServiceAccountCredentialsForOpenStack.newInstance(<ServiceAccountCredentialsForOpenStack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForOpenStack) {
        if (!obj) return;

        models.ServiceAccountCredentialsForOpenStack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForOpenStack): boolean {
        if (models.ServiceAccountCredentialsBaseForOpenStack.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForOpenStack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SSL Verification disabled or not
     */
    insecure: boolean;

}
